// extracted by mini-css-extract-plugin
export default {"outerDiv":"courses-page_outerDiv__ho6Ln","vInfoDiv":"courses-page_vInfoDiv__M7qFG","editBtn":"courses-page_editBtn__c6gjc","addBtn":"courses-page_addBtn__+Gwud"};